import request from '../util/http'


export function queryPackageNames(params) {
  return request({
    url: '/zcjf/data/dataForms/queryPackageNames',
    method: 'get',
    params
  })
}
